import { callEndpoint } from "../baseApi";

export const GetEnterpriseApps = async (idToken) => {
  return await callEndpoint(
    `${process.env.REACT_APP_API}/onboarding_apps`,
    "GET",
    idToken
  );
};